import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { DateTime } from 'luxon'

import { faGavel } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import useAgencySelector from '@hooks/useAgencySelector'
import { generateUrls } from '@hooks/useCampaign'

import type { CampaignModel } from '@models/types'

import useAuctions from '../../hooks/useAuctions'

import AuctionListItem from '../AuctionListItem'
import AuctionsBlankState from '../AuctionBlankState'

const PageContent = () => {
  const { agencyIdParam, selectedAgencyId } = useAgencySelector()

  useLocation()

  // @ts-expect-error TS2322
  const useAuctionsPayload = useAuctions({ agencyIdParam, selectedAgencyId })
  const {
    groupedCampaigns, hasCampaigns, loading,
  } = useAuctionsPayload

  const {
    campaignAuctionOverviewUrl,
  } = generateUrls({}, { prefixRoute: `#/agency/dashboard/agencies/${agencyIdParam}/overview` })

  return (
    <>
      <Helmet>
        <title>Auctions | Realhub</title>
      </Helmet>

      <PageHeader
        nestedNavigation
        activeTabBarItemKey="overview"
        tabBarItems={[
          {
            href: campaignAuctionOverviewUrl,
            icon: faGavel,
            key: 'overview',
            title: 'Overview',
          },
        ]}
        title="Auctions"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation
              locationKey="agency.agencyDashboard.auctions.banner"
            />

            <LoadingModule loading={loading} times={3} />

            {!loading && !hasCampaigns && <AuctionsBlankState />}

            {!loading && hasCampaigns && Object.values(groupedCampaigns).map((grouped) => {
              // @ts-expect-error TS2345
              const title = DateTime.fromISO(grouped.date).toFormat("EEE d'th' LLL yyyy")

              return (
                <DashboardModule title={title}>
                  <Box flexDirection="column">
                    {grouped.items.map((campaign: CampaignModel) => (
                      <AuctionListItem agencyIdParam={agencyIdParam} campaign={campaign} key={campaign.id} />
                    ))}
                  </Box>
                </DashboardModule>
              )
            })}

          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation
              locationKey="agency.agencyDashboard.auctions.sidebar"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
